import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from 'src/components';
import {
  AccidentPlans,
  CriticalPlans,
  DentalPlans,
  DisabilityPlans,
  HospitalPlans,
  LifePlans,
  MedicalPlans,
  PetPlans,
  VisionPlans,
  // DecisionPlans,
} from '../issuerRfpView/features';

import classes from './issuerProposalQuotes.module.scss';

export const IssuerProposalQuotes = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('activeTab');

  return (
    <div className={classes.CarrierRfpViewPage}>
      <PageHeader title="Plan Configurations" />
      <div className={classes.CarrierRfpViewPageContent}>
        {activeTab === 'medical' && <MedicalPlans />}
        {activeTab === 'dental' && <DentalPlans />}
        {activeTab === 'vision' && <VisionPlans />}
        {activeTab === 'life' && <LifePlans />}
        {activeTab === 'disability' && <DisabilityPlans />}
        {activeTab === 'accident' && <AccidentPlans />}
        {activeTab === 'hospital' && <HospitalPlans />}
        {activeTab === 'critical_illness' && <CriticalPlans />}
        {activeTab === 'pet' && <PetPlans />}
        {/* {activeTab === 'decision_support' && <DecisionPlans />} */}
      </div>
    </div>
  );
};
